export default "__VITE_ASSET__BMdY_s4N__"